import { useContext } from "react";
import { AppContext } from "../App";
import { MdClose } from "react-icons/md";
import Backdrop from "./Backdrop";
import { companyInfo, navItems } from "../data/siteContent";

export default function SideBar() {
  const appContext = useContext(AppContext);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({ item });

    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  return (
    <>
      <Backdrop
        style={{
          visibility: appContext.isSideBarOpen ? "visible" : "hidden",
          opacity: appContext.isSideBarOpen ? "1" : "0",
          zIndex: "9999",
          pointerEvents: appContext.isSideBarOpen ? "auto" : "none",
        }}
      />
      <div
        className="SideBar mShadow2"
        data-open={appContext.isSideBarOpen}
        style={{ zIndex: "var(--highestIndex)" }}
      >
        <div className="body mNoScrollBar">
          <div className="sidebar-header">
            <div
              className="logo-holder"
              onClick={() => {
                goTo("home");
              }}
            >
              <img src={companyInfo.logo} alt={companyInfo.shortName} />
            </div>

            <div className="close-btn" onClick={closeSideBar}>
              <MdClose size={32} />
            </div>
          </div>

          <div className="pharmacy-sidebar-intro">
            <p className="pharmacy-sidebar-kicker mNoMargin">
              Africa Geospatial Solutions
            </p>
            <h5 className="font-bold mb-2">
              Survey, mapping, GIS, and drone intelligence for African projects
            </h5>
            <p className="mb-0">
              Mobile navigation shows each page individually for quick access.
            </p>
          </div>

          <a
            href={companyInfo.phoneLink}
            className="btn btn-primary btn-rounded btn-padded btn-block pharmacy-sidebar-call"
          >
            Contact AGS
          </a>

          {navItems.mobile.map((item, index) => (
            <div
              key={item.label}
              className="pill"
              onClick={() => {
                goTo(item.item);
              }}
              data-active={
                item.item === appContext.navItem ||
                (item.item === "home" && !appContext.navItem)
              }
            >
              <span className="nav-marker">
                {String(index + 1).padStart(2, "0")}
              </span>
              <p className="text">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
